import React from "react";
import PropTypes from "prop-types";
import { StaticQuery, graphql } from "gatsby";

function EventCard({ detailTitle, detailDescription, detailImg, type }) {
    return (
            <div className="flex flex-wrap">
            <div className="w-5/6 sm:w-1/2 p-6">
                <h3 className="text-3xl text-gray-800 font-bold leading-none mb-3">{detailTitle}</h3>
               
                {type == "event" ? 
                    <p className="text-gray-600 mb-8"> {detailDescription} <br /><br /> </p>  
                        : 
                    <div className="text-gray-600 mb-8">
                        {detailDescription.map(desc => (
                            <li>
                            {desc}
                            </li>
                        ))}
                    </div>
                }
              
            </div>
            <div className="w-full sm:w-1/2 p-6">
                <img className="w-full md:w-4/5 z-50" src={detailImg} />
            </div>
          </div>
    );
}

EventCard.defaultProps = {
    detailTitle: 'Event Detail #1',
    detailDescription: 'A really long event description',
    detailImg: '../images/connect-hero2.png'
};

EventCard.propTypes = {
    detailTitle: PropTypes.string.isRequired,
    detailDescription: PropTypes.string.isRequired,
    detailImg: PropTypes.string.isRequired
}

export default EventCard;
